import type { CopyShape } from "../../intl";

import type { MENU_LINKS_COPY_PT_BR } from "../menu-links.copy";

export const MENU_LINKS_COPY_EN_US: CopyShape<typeof MENU_LINKS_COPY_PT_BR> = {
  sections: {
    creativeCommand: "Your creative command",
    ideasStudio: "Ideas studio",
    moneyOnTheTable: "Money on the table",
    yourImpact: "Your impact",
  },
  links: {
    dashboard: { label: "Dashboard" },
    agency: { label: "Creators" },
    flow: { label: "Weekly flow" },
    calendar: { label: "Calendar" },
    notes: { label: "Notes" },
    tasks: { label: "Content hub" },
    publi: { label: "Campaign hub" },
    finances: { label: "Finances" },
    calculator: { label: "Brand deal calculator", collabLabel: "Proposals" },
    performance: { label: "Performance" },
  },
  tabLabels: {
    dashboard: "Dashboard",
    agency: "Creators",
    flow: "Flow",
    calendar: "Calendar",
    notes: "Notes",
    tasks: "Content",
    publi: "Campaigns",
    finances: "Finances",
    calculator: "Calculator",
    performance: "Performance",
    proposals: "Proposals",
  },
  menu: "Menu",
};
